import React, { Component } from "react";
import "./Footer.css";
import { Redirect } from "react-router";
import history from "../history/History";
// npm install --save-dev @iconify/react @iconify-icons/simple-icons
//import { Icon, InlineIcon } from '@iconify/react';
// npm install --save-dev @iconify/react @iconify-icons/akar-icons
//import twitterFill from '@iconify-icons/akar-icons/twitter-fill';
//import githubFill from '@iconify-icons/akar-icons/github-fill';
// npm install --save-dev @iconify/react @iconify-icons/teenyicons
//import telegramSolid from '@iconify-icons/teenyicons/telegram-solid';

//import tiktokIcon from '@iconify-icons/simple-icons/tiktok';

import terms from "../pictures/terms.jpg";
import privacy from "../pictures/privacy.jpg";
import { SocialIcon } from "react-social-icons";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { redirect: 0, destination: "/" };
  }

  handleOnClick = (string) => {
    this.setState({ redirect: 1, destination: string });
  };

  openInNewTab = (url) => {
    window.open(url, "_blank");
  };

  render() {
    if (this.state.redirect === 1) {
      this.setState({ redirect: 0 });
      history.push("/");
      return (
        <Redirect
          to={{
            pathname: this.state.destination,
          }}
        />
      );
    }
    return (
      <div className="Footer-container">
        <div className="col col1">
          <div className="innercol">
            <p>BORAT COIN LTD</p>
            <p>COPYRIGHT © 2021</p>
            <p>All Rights Reserved</p>
          </div>
        </div>
        <div className="col col2">
          <div className="innercol">
            <p>More:</p>
            <p>
              <a href="#about">About</a>
            </p>
            <p>
              <a href="#roadmap">Roadmap</a>
            </p>
          </div>
        </div>
        <div className="col col4">
          <div className="innercolIcons">
            <div className="tiktok">
              <a href="http://www.tiktok.com/@boratcoin">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="black"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M8.87898 -0.985655C9.8205 -1 10.7566 -0.9915 11.6917 -1C11.7483 0.084339 12.1444 1.18887 12.9504 1.9555C13.7549 2.74126 14.8928 3.10094 16 3.2226V6.07503C14.9624 6.04156 13.92 5.82905 12.9785 5.38915C12.5684 5.20639 12.1864 4.97104 11.8125 4.73037C11.8077 6.80023 11.8212 8.86743 11.799 10.9288C11.7429 11.9191 11.4111 12.9046 10.8262 13.7207C9.88525 15.0791 8.25202 15.9648 6.57455 15.9924C5.54563 16.0503 4.51778 15.7741 3.641 15.2651C2.18799 14.4214 1.16554 12.877 1.01662 11.2194C0.997861 10.8683 0.994981 10.5166 1.00799 10.1653C1.13748 8.81749 1.81462 7.52808 2.86567 6.65094C4.057 5.62929 5.72584 5.14264 7.28838 5.43059C7.30295 6.47987 7.26032 7.52808 7.26032 8.57735C6.5465 8.34997 5.71235 8.41372 5.08862 8.84034C4.63229 9.13634 4.28744 9.57186 4.10718 10.0798C3.95826 10.439 4.00089 10.8379 4.00952 11.2194C4.18056 12.3818 5.31578 13.3589 6.52761 13.2531C7.33101 13.2446 8.10095 12.7856 8.51964 12.1135C8.65507 11.8782 8.80668 11.6375 8.81478 11.3607C8.88546 10.0936 8.8574 8.83184 8.86603 7.56474C8.87197 4.70912 8.8574 1.86146 8.87952 -0.985124L8.87898 -0.985655Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div className="twitter">
              <a href="https://twitter.com/theboratcoin">
                <svg
                  width="19"
                  height="16"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 1.89404C18.3377 2.21528 17.626 2.43239 16.879 2.53006C17.6415 2.03017 18.227 1.23857 18.5027 0.295396C17.7778 0.765896 16.9847 1.09739 16.1577 1.27556C15.484 0.490584 14.5243 0 13.4621 0C11.4226 0 9.76909 1.80852 9.76909 4.03911C9.76909 4.35573 9.80179 4.66397 9.86472 4.95967C6.79558 4.79117 4.07448 3.18314 2.25304 0.739375C1.93523 1.33594 1.75312 2.02986 1.75312 2.77C1.75312 4.17139 2.40513 5.40765 3.39597 6.13203C2.80953 6.11194 2.23599 5.93869 1.72323 5.62676C1.72302 5.64368 1.72302 5.66059 1.72302 5.67759C1.72302 7.63462 2.99596 9.26718 4.68529 9.63825C4.14148 9.80002 3.57107 9.82369 3.01762 9.70747C3.48752 11.3122 4.85137 12.4799 6.46729 12.5126C5.20342 13.5959 3.61105 14.2417 1.88095 14.2417C1.58282 14.2417 1.28891 14.2225 1 14.1852C2.63427 15.3313 4.57539 16 6.66086 16C13.4535 16 17.1679 9.84513 17.1679 4.50754C17.1679 4.33235 17.1644 4.15816 17.1573 3.98497C17.8802 3.41331 18.5042 2.70526 19 1.89404"
                    fill="#55ACEE"
                  />
                </svg>
              </a>
            </div>
            <div className="telegram">
              <a href="https://t.me/theboratcoin">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C3.58169 0 0 3.58169 0 8C0 12.4183 3.58169 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58169 12.4183 0 8 0Z"
                    fill="#40B3E0"
                  />
                  <path
                    d="M11.8927 4.60188L10.4638 11.8062C10.4638 11.8062 10.264 12.3058 9.7144 12.066L6.41703 9.538L5.21803 8.9585L3.19965 8.279C3.19965 8.279 2.8899 8.16912 2.8599 7.92931C2.8299 7.6895 3.20965 7.55963 3.20965 7.55963L11.2332 4.41213C11.2332 4.41213 11.8927 4.12238 11.8927 4.602"
                    fill="white"
                  />
                  <path
                    d="M6.16364 11.7252C6.16364 11.7252 6.06739 11.7162 5.94739 11.3364C5.82758 10.9568 5.21802 8.95837 5.21802 8.95837L10.0641 5.88087C10.0641 5.88087 10.344 5.711 10.334 5.88087C10.334 5.88087 10.3839 5.91087 10.234 6.05075C10.0841 6.19069 6.42708 9.478 6.42708 9.478"
                    fill="#D2E5F1"
                  />
                  <path
                    d="M7.68133 10.5072L6.37714 11.6963C6.37714 11.6963 6.27514 11.7737 6.16364 11.7252L6.41339 9.51644"
                    fill="#B5CFE4"
                  />
                </svg>
              </a>
            </div>
            <div className="reddit">
              <a>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                    fill="#FF4500"
                  />
                  <path
                    d="M13.3219 8.07625C13.3219 7.42775 12.7974 6.91269 12.1583 6.91269C11.8564 6.91228 11.566 7.02846 11.3477 7.237C10.5466 6.66469 9.44969 6.29281 8.22894 6.24512L8.76294 3.74631L10.4988 4.11819C10.5179 4.55694 10.8803 4.90987 11.3286 4.90987C11.7864 4.90987 12.1583 4.538 12.1583 4.08C12.1583 3.62225 11.7864 3.25031 11.3286 3.25031C11.0044 3.25031 10.7181 3.44106 10.5846 3.71769L8.64863 3.30756C8.59138 3.29794 8.53413 3.30756 8.49594 3.33619C8.44826 3.36481 8.41969 3.41244 8.41026 3.46969L7.81876 6.25456C6.57894 6.29281 5.46301 6.66469 4.65238 7.24656C4.43404 7.03803 4.14361 6.92187 3.84169 6.92231C3.19313 6.92231 2.67813 7.44675 2.67813 8.08587C2.67813 8.56269 2.96419 8.96319 3.36488 9.14456C3.34542 9.26117 3.33585 9.37922 3.33626 9.49744C3.33626 11.2903 5.42501 12.7497 8.00007 12.7497C10.5752 12.7497 12.6639 11.2999 12.6639 9.49744C12.6639 9.37923 12.6543 9.26123 12.6353 9.14456C13.0358 8.96319 13.3219 8.55306 13.3219 8.07625V8.07625ZM5.32951 8.90594C5.32951 8.44819 5.70138 8.07625 6.15938 8.07625C6.61713 8.07625 6.98907 8.44812 6.98907 8.90594C6.98907 9.36375 6.61719 9.73581 6.15938 9.73581C5.70144 9.74519 5.32951 9.36375 5.32951 8.90594ZM9.97432 11.1091C9.40207 11.6814 8.31476 11.7196 8.00007 11.7196C7.67582 11.7196 6.58857 11.6718 6.02569 11.1091C5.94001 11.0233 5.94001 10.8897 6.02569 10.8039C6.11157 10.7182 6.24507 10.7182 6.33094 10.8039C6.69344 11.1664 7.45644 11.2903 8.00007 11.2903C8.54376 11.2903 9.31619 11.1664 9.66907 10.8039C9.75494 10.7182 9.88844 10.7182 9.97432 10.8039C10.0506 10.8897 10.0506 11.0233 9.97432 11.1091ZM9.82163 9.74525C9.36382 9.74525 8.99194 9.37337 8.99194 8.91556C8.99194 8.45775 9.36382 8.08587 9.82163 8.08587C10.2796 8.08587 10.6514 8.45775 10.6514 8.91556C10.6514 9.36369 10.2796 9.74525 9.82163 9.74525Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
            {/*<br/>
                        <a href="https://twitter.com/theboratcoin">
                            Twitter
                        </a>
                        <br/><br/>
                        <a href="https://www.github.com/Alibek10599">
                            Github
                        </a>
                        <br/><br/>
                        <a href="http://www.tiktok.com/@boratcoin">
                            Tik-Tok
                        </a>*/}
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/footer/Footer.js